module.exports = __webpack_public_path__ + "static/media/ctpat.9d1baded.png";